import { withFormik } from 'formik';
import * as Yup from 'yup';
import Profile from './Profile';
import { editProfile, fetchAboutMe } from '../services/index'
import { toast } from 'react-toastify';


const validationSchema = Yup.object().shape({
  fullName: Yup.string()
    .min(2, 'Name is too short')
    .required('Name is required'),
  email: Yup.string()
    .email('Email is not valid')
    .required('Email is required'),
  dob: Yup.date()
    .typeError('Please enter date of birth')
    .required('Date of birth is required'),
  phone: Yup.string()
    .matches(/^[6-9]\d{9}$/, 'Please enter valid number.')
    .required('Phone number is required'),
  phone2: Yup.string()
    .min(10, 'Phone number is not valid'),
  children: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .min(2, 'Name is too short'),
        dob: Yup.date().typeError('Please enter date of birth'),        
      })
    ),
  contacts: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .min(2, 'Name is too short'),
        email: Yup.string().email("Enter a valid email").required("Please enter a valid email"),
        phone: Yup.string().matches(/^[6-9]\d{9}$/, 'Enter a valid number')
      })
    )
})


const EnhancedUserProfile = withFormik({
  mapPropsToValues: (props) => {

    // const user = await fetchAboutMe();
    console.log(props);
    return {
      fullName: props.fullName || '',
      phone: props.phone || '',
      phone2: '',
      email: props.email || '',
      dob: props.dob.toString() !== "Invalid Date" ? props.dob : null,
      gender: props.gender || '',
      children: props.children || [],
      contacts: props.contacts || []
    }
  },

  handleSubmit: async (values, { setSubmitting }) => {
    const res = await editProfile(values);

    if(res.status !== 200) {
      toast.error('Some error occured')
    }

    if(res.data.error == true) {
      toast.error(res.data.message)
    }

    toast.success(res.data.message);


  },
  validationSchema: validationSchema

})(Profile);


export default EnhancedUserProfile;


// WEBPACK FOOTER //
// ./src/views/Account/EnhancedUserProfile.js